import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { FixtureList } from '../../competition-list/competition.models';
import { CompetitionService } from '../../competition-list/services/competition.service';

export const marketGroupResolver: ResolveFn<FixtureList> = (route: ActivatedRouteSnapshot) => {
    const dependencyService = inject(CompetitionService);

    return dependencyService.getMarketGroupData(route);
};
